export function formatDate(value) {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function formatHourBucket(value) {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  const hour = String(value.getHours()).padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:00:00`;
}

function parseRangeValue(value, boundary = 'start') {
  if (typeof value !== 'string' || !value)
    return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(value))
    return new Date(`${value}T${boundary === 'end' ? '23:59:59' : '00:00:00'}`);

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export const ANALYSIS_STATUS_BY_TRANSACTION_CARD_TITLE = {
  'Aguardando Análise': 'WAITING_ANALYSIS',
  'Em Análise': 'ANALYSIS',
  Reportadas: 'REPORT',
  Finalizadas: 'FINALIZED',
};

export const ANALYSIS_STATUS_BY_DASHBOARD_TRANSACTION_CARD_TITLE = {
  'Alertas Abertos': 'WAITING_ANALYSIS',
  'Alertas Fechados': 'FINALIZED',
  'Casos Abertos': 'ANALYSIS',
  'Casos Fechados': 'REPORT',
};

export const ANALYSIS_STATUS_BY_MONITORING_CARD_ID = {
  'waiting-analysis': 'WAITING_ANALYSIS',
  analysis: 'ANALYSIS',
  report: 'REPORT',
  finalized: 'FINALIZED',
};

export const AML_TRANSACTIONS_FINANCIAL_CARDS = [
  {
    title: 'Total',
    value: 'R$ 0,00',
    interval: '',
    trend: 'up',
    labels: [],
    data: [],
  },
  {
    title: 'Finalizadas',
    value: 'R$ 0,00',
    interval: '',
    trend: 'down',
    labels: [],
    data: [],
  },
  {
    title: 'Aguardando Análise',
    value: 'R$ 0,00',
    interval: '',
    trend: 'neutral',
    labels: [],
    data: [],
  },
  {
    title: 'Em Análise',
    value: 'R$ 0,00',
    interval: '',
    trend: 'down',
    labels: [],
    data: [],
  },
  {
    title: 'Reportadas',
    value: 'R$ 0,00',
    interval: '',
    trend: 'neutral',
    labels: [],
    data: [],
  },
];

export const AML_TRANSACTIONS_QUANTITY_CARDS = [
  {
    title: 'Total',
    value: '0',
    interval: '',
    trend: 'up',
    labels: [],
    data: [],
  },
  {
    title: 'Finalizadas',
    value: '0',
    interval: '',
    trend: 'down',
    labels: [],
    data: [],
  },
  {
    title: 'Aguardando Análise',
    value: '0',
    interval: '',
    trend: 'neutral',
    labels: [],
    data: [],
  },
  {
    title: 'Em Análise',
    value: '0',
    interval: '',
    trend: 'down',
    labels: [],
    data: [],
  },
  {
    title: 'Reportadas',
    value: '0',
    interval: '',
    trend: 'neutral',
    labels: [],
    data: [],
  }
];

export const DASHBOARD_TRANSACTION_CARDS = [
  {
    title: 'Alertas Abertos',
    value: '0',
    interval: '',
    trend: 'up',
    data: [],
  },
  {
    title: 'Alertas Fechados',
    value: '0',
    interval: '',
    trend: 'down',
    data: [],
  },
  {
    title: 'Casos Abertos',
    value: '0',
    interval: '',
    trend: 'neutral',
    data: [],
  },
  {
    title: 'Casos Fechados',
    value: '0',
    interval: '',
    trend: 'down',
    data: [],
  },
  {
    title: 'Média de Risco Financeiro',
    value: 'R$ 0,00',
    interval: '',
    trend: 'neutral',
    data: [],
  },
  {
    title: 'Média de casos completos',
    value: '0',
    interval: '',
    trend: 'down',
    data: [],
  },
];

export const AML_TRANSACTIONS_GRID_TEXT = {
  title: 'Transações Suspeitas',
  loading: 'Carregando dados de transações...',
  financialSection: 'Financeiro (R$)',
  quantitativeSection: 'Quantitativo',
  detailsSection: 'Detalhes',
};

export const DASHBOARD_TRANSACTION_GRID_TEXT = {
  title: 'Transações',
  loading: 'Carregando dados de transações...',
  detailsSection: 'Detalhes',
};

export const AML_DASHBOARD_GRID_TEXT = {
  pageTitle: 'Dashboard',
  loading: 'Carregando dados do dashboard...',
  cards: {
    suspiciousFinancial: 'Transações Suspeitas (R$)',
    suspiciousQuantity: 'Transações Suspeitas (Quantitativo)',
    suspiciousClients: 'Clientes Suspeitos',
  },
  monitoring: {
    quantityTitle: 'Transações Suspeitas por Status (Quantitativo)',
    financialTitle: 'Transações Suspeitas por Status (Volume financeiro)',
    description: 'Classificação mediante status das transações monitoradas',
    labels: {
      waitingAnalysis: 'Aguardando análise',
      analysis: 'Em análise',
      report: 'Reportadas',
      finalized: 'Finalizadas',
    },
  },
  risk: {
    quantityTitle: 'Transações por Tipo de Risco (Quantitativo)',
    financialTitle: 'Transações por Tipo de Risco (Volume financeiro)',
    description: 'Classificação mediante risco encontrado das transações monitoradas',
    labels: {
      low: 'Baixa',
      medium: 'Média',
      high: 'Alta',
    },
  },
};

export function getDateRangeByFilter(filter, now = new Date()) {
  const endDate = new Date(now);
  const startDate = new Date(endDate);

  switch (filter) {
    case 'ONE_DAY':
      startDate.setDate(endDate.getDate() - 1);
      break;
    case 'SEVEN_DAYS':
      startDate.setDate(endDate.getDate() - 6);
      break;
    case 'ONE_MONTH':
      startDate.setDate(endDate.getDate() - 29);
      break;
    case 'THREE_MONTHS':
      startDate.setMonth(endDate.getMonth() - 2);
      break;
    case 'SIX_MONTHS':
      startDate.setMonth(endDate.getMonth() - 5);
      break;
    case 'ONE_YEAR':
      startDate.setMonth(endDate.getMonth() - 11);
      break;
    default:
      startDate.setFullYear(endDate.getFullYear() - 4);
  }

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  };
}

function isValidDateInput(dateValue) {
  return typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue);
}

export function getDateRangeFromFilterState(filterState) {
  const relativeFilter = filterState?.value || 'SEVEN_DAYS';
  const fallbackRange = getDateRangeByFilter(relativeFilter);
  const today = formatDate(new Date());

  if (filterState?.mode !== 'custom')
    return fallbackRange;

  const customStartDate = filterState?.customStartDate;
  const customEndDate = filterState?.customEndDate;

  if (!isValidDateInput(customStartDate) || !isValidDateInput(customEndDate))
    return fallbackRange;

  if (customStartDate > today || customEndDate > today)
    return fallbackRange;

  if (customStartDate > customEndDate)
    return fallbackRange;

  return {
    startDate: customStartDate,
    endDate: customEndDate,
  };
}

export function getApiDateRangeFromFilterState(filterState, now = new Date()) {
  if (filterState?.mode !== 'custom' && filterState?.value === 'ONE_DAY') {
    const endDate = new Date(now);
    const startDate = new Date(endDate);
    startDate.setMinutes(0, 0, 0);
    startDate.setHours(startDate.getHours() - 23);

    return {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
  }

  return getDateRangeFromFilterState(filterState);
}

export function getGroupByByFilter(filter) {
  switch (filter) {
    case 'ONE_DAY':
    case 'SEVEN_DAYS':
    case 'ONE_MONTH':
      return 'days';
    case 'THREE_MONTHS':
    case 'SIX_MONTHS':
    case 'ONE_YEAR':
      return 'month';
    default:
      return 'year';
  }
}

export function getGroupByFromFilterState(filterState) {
  if (filterState?.mode !== 'custom')
    return getGroupByByFilter(filterState?.value || 'SEVEN_DAYS');

  const customStartDate = filterState?.customStartDate;
  const customEndDate = filterState?.customEndDate;

  if (!isValidDateInput(customStartDate) || !isValidDateInput(customEndDate))
    return getGroupByByFilter(filterState?.value || 'SEVEN_DAYS');

  const start = new Date(`${customStartDate}T00:00:00`);
  const end = new Date(`${customEndDate}T00:00:00`);

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || start > end)
    return getGroupByByFilter(filterState?.value || 'SEVEN_DAYS');

  const millisecondsInDay = 24 * 60 * 60 * 1000;
  const rangeInDays = Math.floor((end.getTime() - start.getTime()) / millisecondsInDay) + 1;

  if (rangeInDays <= 31)
    return 'days';

  if (rangeInDays <= 366)
    return 'month';

  return 'year';
}

export function getApiGroupByFromFilterState(filterState) {
  if (filterState?.mode !== 'custom' && filterState?.value === 'ONE_DAY')
    return 'hour';

  return getGroupByFromFilterState(filterState);
}

export function getIntervalLabelByFilter(filter) {
  switch (filter) {
    case 'ONE_DAY':
      return 'Últimas 24 horas';
    case 'SEVEN_DAYS':
      return 'Últimos 7 dias';
    case 'ONE_MONTH':
      return 'Últimos 30 dias';
    case 'THREE_MONTHS':
      return 'Últimos 3 meses';
    case 'SIX_MONTHS':
      return 'Últimos 6 meses';
    case 'ONE_YEAR':
      return 'Últimos 12 meses';
    default:
      return 'Últimos 5 anos';
  }
}

export function formatCount(value) {
  return new Intl.NumberFormat('pt-BR').format(Number(value) || 0);
}

export function formatBrl(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(Number(value) || 0);
}

export function formatBrlTooltipValue(item) {
  return formatBrl(item?.value ?? item ?? 0);
}

export function normalizeBucketKey(value, groupBy) {
  const rawValue = String(value || '');

  if (groupBy === 'hour' || groupBy === 'hours') {
    const parsed = parseRangeValue(rawValue);

    if (parsed)
      return formatHourBucket(parsed);

    const rawHour = rawValue.replace('T', ' ').slice(0, 13);
    return `${rawHour}:00:00`;
  }

  if (groupBy === 'year' || groupBy === 'years')
    return rawValue.slice(0, 4);

  if (groupBy === 'month' || groupBy === 'months')
    return rawValue.slice(0, 7);

  return rawValue.slice(0, 10);
}

export function generateBucketKeys(startDate, endDate, groupBy) {
  const start = parseRangeValue(startDate, 'start');
  const end = parseRangeValue(endDate, 'end');

  if (!start || !end || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || start > end)
    return [];

  if (groupBy === 'hour' || groupBy === 'hours') {
    const keys = [];
    const cursor = new Date(start);
    cursor.setMinutes(0, 0, 0);
    const last = new Date(end);

    while (cursor <= last) {
      keys.push(formatHourBucket(cursor));
      cursor.setHours(cursor.getHours() + 1);
    }

    return keys;
  }

  if (groupBy === 'year' || groupBy === 'years') {
    const keys = [];
    for (let year = start.getFullYear(); year <= end.getFullYear(); year += 1)
      keys.push(String(year));
    return keys;
  }

  if (groupBy === 'month' || groupBy === 'months') {
    const keys = [];
    const cursor = new Date(start.getFullYear(), start.getMonth(), 1);
    const last = new Date(end.getFullYear(), end.getMonth(), 1);

    while (cursor <= last) {
      const year = cursor.getFullYear();
      const month = String(cursor.getMonth() + 1).padStart(2, '0');
      keys.push(`${year}-${month}`);
      cursor.setMonth(cursor.getMonth() + 1);
    }

    return keys;
  }

  const keys = [];
  const cursor = new Date(start);

  while (cursor <= end) {
    keys.push(formatDate(cursor));
    cursor.setDate(cursor.getDate() + 1);
  }

  return keys;
}

export function formatHistoryLabel(dateValue, groupBy) {
  const isHourGroup = groupBy === 'hour' || groupBy === 'hours';
  const isYearGroup = groupBy === 'year' || groupBy === 'years';
  const isMonthGroup = groupBy === 'month' || groupBy === 'months';
  const safeDate = isHourGroup
    ? parseRangeValue(dateValue)
    : isYearGroup
    ? new Date(`${dateValue}-01-01T00:00:00`)
    : isMonthGroup
      ? new Date(`${dateValue}-01T00:00:00`)
      : new Date(`${dateValue}T00:00:00`);

  if (Number.isNaN(safeDate.getTime()))
    return dateValue;

  if (isYearGroup)
    return safeDate.getFullYear().toString();

  if (isMonthGroup) {
    const monthName = safeDate.toLocaleDateString('pt-BR', { month: 'short' }).replace(/\.$/, '');
    const year = safeDate.getFullYear().toString().slice(-2);
    return `${monthName.charAt(0).toUpperCase() + monthName.slice(1)}. ${year}`;
  }

  if (isHourGroup) {
    const day = safeDate.toLocaleDateString('pt-BR', { day: '2-digit' });
    const month = safeDate.toLocaleDateString('pt-BR', { month: 'short' });
    const hour = safeDate.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', hour12: false });
    return `${month} ${day} ${hour}`;
  }

  const day = safeDate.toLocaleDateString('pt-BR', { day: '2-digit' });
  const month = safeDate.toLocaleDateString('pt-BR', { month: 'short' });
  return `${month} ${day}`;
}

export function getTrendByPercentage(value) {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue) || numericValue <= 0)
    return 'neutral';

  if (numericValue <= 25)
    return 'warning';

  return 'down';
}

export function formatPercentage(value) {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue))
    return '';

  return `${numericValue.toFixed(2)}%`;
}
